import { useEffect, useMemo, useRef } from 'react';
import { useExperimentGroupValue } from 'shared/src/context/UserContext/useExperimentGroup';
import { isNil, isNotNil } from 'shared/src/utils';
import { useGoodsOptionsBrief } from '../components/SelectOptionBottomSheet/queries/useGoodsOptionsBrief';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';

export type InlineOptionMode = 'disabled' | 'variantB' | 'variantC';

export const useInlineOptionMode = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}): InlineOptionMode => {
  const { data: brief } = useGoodsOptionsBrief();
  const expGroup = useExperimentGroupValue({ sno: 'EXP1701' });
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const loggedRef = useRef(false);

  const eligible = useMemo(() => {
    if (!enabled) return false;
    if (!brief) return false;
    return (
      brief.enable_quick_option_pick === true &&
      isNil(brief.text_option) &&
      brief.option_groups.length === 2 &&
      brief.option_groups.every(g => isNotNil(g.first_goods_option_sno))
    );
  }, [brief, enabled]);

  useEffect(() => {
    if (loggedRef.current || !eligible) return;
    logGoodsAnalytics({ name: 'CHECK_EXP_1701_GROUP' });
    loggedRef.current = true;
  }, [eligible, logGoodsAnalytics]);

  return useMemo<InlineOptionMode>(() => {
    if (!eligible) return 'disabled';
    if (expGroup === 'C') return 'variantC';
    if (expGroup === 'B') return 'variantB';
    return 'disabled';
  }, [eligible, expGroup]);
};
